<template>

  <!-- <a-affix :offset-top="0">  </a-affix> -->

  <!-- 固定头部 :style="{ position: 'fixed', zIndex: 1, width: '100%', margin: '0 0 0 0' }" -->
  <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1000, width: '100%', margin: '0 0 0 0' }">

    <!-- 左侧logo -->
    <div class="logo" @click="jumpClick">
      <span>佰特编码Wiki</span>
      <!-- src/assets 下 require('@/assets/wiki.png') -->
      <!-- public 下 '/image/wiki.png' -->
      <!-- <a-image :width="40" :src="require('@/assets/wiki.png')" :preview="false" /> -->
    </div>

    <!-- 导航菜单 -->
    <!-- v-model:selectedKeys="currentKeys"  @select="onSelect"  -->
    <!-- [$route.path] 根据当前路由选中相应菜单 -->
    <a-menu theme="light" mode="horizontal" :style="{ lineHeight: '64px' }" :defaultSelectedKeys="[$route.path]"
      :selectedKeys="[$route.path]">
      <a-menu-item key="/">
        <router-link to="/">首页</router-link>
      </a-menu-item>
      <a-menu-item key="/track">
        <router-link to="/track">学习路径</router-link>
      </a-menu-item>
      <a-menu-item key="/video">
        <a href="https://www.lcbait.com" target="_blank">视频教程</a>
      </a-menu-item>
      <a-menu-item key="/about">
        <router-link to="/about">关于我们</router-link>
      </a-menu-item>

      <!-- :style="user.id ? {} : { display: 'none' }" -->
      <a-menu-item key="/admin/user" v-if="user.id">
        <router-link to="/admin/user">用户管理</router-link>
      </a-menu-item>
      <a-menu-item key="/admin/ebook" v-if="user.id">
        <router-link to="/admin/ebook">电子书管理</router-link>
      </a-menu-item>
      <a-menu-item key="/admin/category" v-if="user.id">
        <router-link to="/admin/category">分类管理</router-link>
      </a-menu-item>
      <a-menu-item key="/admin/track" v-if="user.id">
        <router-link to="/admin/track">路径管理</router-link>
      </a-menu-item>
      <a-menu-item key="/admin/statistic" v-if="user.id">
        <router-link to="/admin/statistic">数据统计</router-link>
      </a-menu-item>


      <!-- 登录&退出登录 background: transparent; -->
      <a-layout style="position: absolute;right: 20px;display:inline-block;background:transparent;">
        <!-- 退出 -->
        <a-popconfirm title="确认退出登录?" ok-text="是" cancel-text="否" @confirm="logout()">
          <a class="login-menu color-blue" v-if="user.id">
            <span>退出登录</span>
          </a>
        </a-popconfirm>
        <!-- 登录按钮 -->
        <a class="login-menu" v-if="user.id">
          <span>您好：{{ user.name }}</span>
        </a>
        <span v-else>
          <router-link to="/login" class="color-blue">登录</router-link>
        </span>
      </a-layout>

    </a-menu>

  </a-layout-header>


</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import store from "@/store";
import useRouter from '@/router'


// 引用public/js/md5.js 
declare let hexMd5: any;
declare let KEY: any;

export default defineComponent({
  name: 'TheHeader',// 同 'the-header'

  setup() {
    // logo 路径
    const logoUrl = computed(() => require('@/assets/logo.png'));
    console.log(logoUrl)

    // 卡页显示
    const currentKeys = ref<string[]>(['/']);

    // 登录后保存
    const user = computed(() => store.state.user);
    console.log('user => ', user)

    // 退出登录
    const logout = () => {
      console.log("退出登录开始");

      axios.get('/user/logout/' + user.value.token).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          message.success("退出登录成功！");
          store.commit("removeUser", {});
          // 跳转到首页
          useRouter.push({ path: '/' })
          //useRouter.replace({ path: '/' });
          // 刷新一下当前页面
          window.location.reload()
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 菜单选中事件
     * @param selectedKeys 
     */
    const onSelect = (selectedKeys: any) => {
      console.log('selectedKeys', selectedKeys)
      currentKeys.value = [selectedKeys.key]; // 更新激活的菜单项
      // 这里可以添加其他逻辑，比如根据选中的菜单项进行页面跳转等
    };

    /**
     * 点击logo跳转
     */
    const jumpClick = () => {
      console.log('jumpIndex...')
      // 跳转到首页
      currentKeys.value = ['/']
      useRouter.push({ path: '/' })

    };


    /**
     * 获取当前的路由
     */
    onMounted(() => {
      console.log('routes => ', useRouter.getRoutes())
      console.log('currentRoute => ', useRouter.currentRoute.value)
      console.log('currentRoute fullPath => ', useRouter.currentRoute.value.fullPath)
      console.log('currentRoute path => ', useRouter.currentRoute.value.path)
    });

    return {
      currentKeys,
      user,
      logout,
      logoUrl,
      onSelect,
      jumpClick
    }
  }

});
</script>
<style scoped>
.logo {
  width: 140px;
  height: 31px;
  float: left;
  color: #1296db;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.login-menu {
  float: right;
  color: gray;
  padding-left: 10px;
}

.header {
  background: white;
}

.color-blue {
  color: #1296db;
}

/* 导航菜单颜色 */

/* 悬浮,选择颜色 */
:deep .ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item :hover,
:deep .ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item-selected {
  color: #1296db;
}

/* 悬浮下划线,选择后下划线 */
:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after),
:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
  border-bottom: 0.5px solid #1296db;
  /* border-bottom-color: #1296db; */
}
</style>
